import { z } from '@/utils/zod'

export const OrganizationEmailSenderSchema = z.object({
    name: z
        .string()
        .min(1)
        .regex(/^[^\r\n]+$/)
        .nullable(),
    localPart: z
        .string()
        .min(1)
        .refine((value) => !value.includes('@') && z.email().safeParse(`${value}@example.org`).success)
        .nullable(),
})

export type OrganizationEmailSender = z.infer<typeof OrganizationEmailSenderSchema>
